import { render, staticRenderFns } from "./fieldsStringerPallet.vue?vue&type=template&id=8fc800e6&lang=pug"
import script from "./fieldsStringerPallet.vue?vue&type=script&lang=js"
export * from "./fieldsStringerPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports